/**
 * Copy for the claim's chrome: the bar, leaving, app home, the sent screen and
 * Loft's stage. The loop's own copy is in `claim/claim.content.ts` and each
 * ask's in `claim/asks.ts`.
 *
 * `Margaret` is replaced with the claimant's first name at render time, so
 * every line reads right for whichever scenario is running.
 */

export const BAR = {
  title: 'Attendance Allowance',
  steps: ['Tell us', 'Check', 'Send'] as const,
};

export const LEAVE = {
  label: 'Leave the claim',
  title: 'Leave the claim?',
  body: 'Your answers are saved. You can pick this up where you left off.',
  confirm: 'Leave',
  stay: 'Keep going',
};

export const HOME = {
  carryOn: 'Carry on where you left off',
  claimName: 'Attendance Allowance',
  claimDescription: 'Margaret’s claim, with your Care Adviser',
  more: 'Also for Margaret',
  cards: [
    {
      title: 'Benefits calculator',
      subtitle: 'See what else Margaret could claim',
    },
    { title: 'Care assessment', subtitle: 'Assess her care needs' },
  ],
};

export const SENT = {
  title: 'Sent to your Care Adviser',
  description:
    'They’ll look through Margaret’s claim and get in touch to go through what’s left.',
  summaryLabel: 'What they’ve received',
  answers: (n: number) => `${n} checked answers`,
  left: (n: number) =>
    n === 1
      ? '1 question to talk through together'
      : `${n} questions to talk through together`,
  nextLabel: 'What happens next',
  next: [
    'Your adviser checks the answers and goes through anything you set aside.',
    'Margaret, or someone allowed to act for her, signs the declaration.',
    'The claim goes to the DWP.',
  ],
  home: 'Back to home',
  download: 'Download the draft form',
};

/** The Loft chrome around the prototype. */
export const STAGE = {
  badge: 'Prototype · sample data',
  scenario: 'Scenario',
  about: 'About this prototype',
  family: 'Family',
  adviser: 'Care Adviser',
};
